import RestResource from '../rest.service';
import Service from '../api.service';

export default class DistributorsService extends RestResource {
  map(payload) {
    return {
      seller_id: typeof payload.seller === 'object' ? payload.seller.id : payload.seller,
      city_id: payload.city,
      email: payload.email,
      alternative_email: payload.alternativeEmail,
      name: payload.name,
      code: payload.code || '####',
      cuit: payload.cuit,
      address: payload.address,
      warehouse_address: payload.warehouseAddress,
      phone: payload.phone,
    };
  }

  sells(campaignId, params = {}) {
    return Service.get(`distributor-sells/${campaignId}`, { params: params }).catch(this.handleErrors);
  }

  search(params) {
    return Service.get(`${this.getResource()}/search`, { params }).catch(this.handleErrors);
  }

  constructor() {
    super('distributors');
  }
}
